import React from "react";
import { Modal } from "antd";
import "./index.css";

type TranslationModalProps = {
  isVisible: boolean;
  title: string | React.ReactNode;
  content: React.ReactNode;
  onOk?: () => void;
  onCancel?: () => void;
  width?: number | string;
  footer?: React.ReactNode;
  className?: string;
};

const TranslationModal: React.FC<TranslationModalProps> = ({
  isVisible,
  title,
  content,
  onOk,
  onCancel,
  footer,
  width = 500,
  className,
}) => (
  <Modal
    title={title}
    visible={isVisible}
    onOk={onOk}
    onCancel={onCancel}
    className={className}
    footer={null}
    width={width}
  >
    {content}
  </Modal>
);

export default TranslationModal;
